import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PresentPlayIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      clipRule="evenodd"
      d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM1 2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2ZM5.2 4.23267C5.2 3.9162 5.5501 3.72506 5.8163 3.89619L11.6766 7.66353C11.9215 7.82098 11.9215 8.17902 11.6766 8.33647L5.8163 12.1038C5.5501 12.2749 5.2 12.0838 5.2 11.7673V4.23267Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
